import { render, staticRenderFns } from "./ContactPerDeps.vue?vue&type=template&id=4dc48421&"
import script from "./ContactPerDeps.vue?vue&type=script&lang=js&"
export * from "./ContactPerDeps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports